module.exports = __webpack_public_path__ + "img/medico.48d160cb.png";